/* CustomFieldFormFooter.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Y7lL45zaO%7Bpadding-inline%3Avar(--ds-space-200%2C1pc)%7D");
import React from 'react';
import ButtonGroup from '@atlaskit/button/button-group';
import Button from '@atlaskit/button/default/button';
import { FormFooter } from '@atlaskit/form/form-footer';
import { Box } from '@atlaskit/primitives/compiled/box';
import { FormattedMessage, useIntl } from 'react-intl';
type CustomFieldFormFooterProps = {
  mode: 'create' | 'edit';
  onCancel: () => void;
  isFormValid: boolean;
  isLoading?: boolean;
};
const styles = {
  saveButton: "_2Y7lL45zaO"
};
export const CustomFieldFormFooter = ({
  mode,
  onCancel,
  isFormValid,
  isLoading
}: CustomFieldFormFooterProps): React.JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  return <FormFooter>
			<ButtonGroup label={formatMessage({
      id: 'townsquare.teams-settings.custom-field-form.form-buttons-label',
      defaultMessage: 'Form buttons',
      description: 'Label for the form buttons'
    })}>
				<Button onClick={onCancel} appearance="subtle">
					<FormattedMessage id="townsquare.teams-settings.custom-field-form.cancel-button" defaultMessage="Cancel" description="Button to cancel custom field form" />
				</Button>
				<Button appearance="primary" type="submit" isDisabled={!isFormValid || isLoading} isLoading={isLoading}>
					{mode === 'create' ? <FormattedMessage id="townsquare.teams-settings.custom-field-form.create-button" defaultMessage="Create field" description="Button to create a custom field" /> : <Box xcss={styles.saveButton}>
							<FormattedMessage id="townsquare.teams-settings.custom-field-form.save-button" defaultMessage="Save" description="Button to save changes to a custom field" />
						</Box>}
				</Button>
			</ButtonGroup>
		</FormFooter>;
};